import type { JSX } from 'react';
import { Link } from 'react-router-dom';

export function NotFoundScreen(): JSX.Element {
  return (
    <main className="mx-auto flex min-h-svh max-w-md flex-col justify-center gap-4 px-4 py-10">
      <h1 className="text-2xl font-semibold">Page not found</h1>
      <p className="text-sm text-slate-700">
        The URL you followed does not exist.
      </p>
      <Link className="text-sm text-slate-900 underline" to="/app">
        Go to the app
      </Link>
    </main>
  );
}
